var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-toolbar",
    {
      staticClass: "appNavigationBar",
      attrs: { color: "#" + _vm.color, height: "40" },
    },
    [
      _c(
        "v-toolbar-items",
        [
          _c("router-link", { attrs: { to: "/", tag: "a" } }, [
            _c("span", [
              _c("img", {
                attrs: {
                  src: require("../../../assets/JLLlogo.png"),
                  height: "40px",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _vm.$store.getters.isInRoleArr(
            "View_LegalArea/LegalClient/ClientList,LEGAL,LEGAL_MNG,LEGAL_ADM,LEGAL_ASS,LEGAL_ASSISTANT_WITH_REOPEN,ADMIN"
          )
            ? _c(
                "router-link",
                {
                  class: {
                    selected: _vm.selectedPath
                      .toLowerCase()
                      .includes("/duediligence"),
                    shadowhover: true,
                  },
                  attrs: { to: "/DueDiligence", tag: "a" },
                },
                [
                  _c(
                    "span",
                    { staticClass: "nav-button", attrs: { color: "#ffffff" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "components.navigation_bar.title_due_diligence"
                            )
                          )
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.isInRoleArr(
            "ADMIN,R_TETRIS_ESIGN_ADMIN,R_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index,View_ESignArea/ESign/Index,JLLT_VIEW,HR_ADMIN"
          )
            ? _c(
                "v-menu",
                {
                  attrs: {
                    dark: "",
                    "offset-y": "",
                    transition: "slide-y-transition",
                    rounded: "10",
                    "content-class": "elevation-2",
                  },
                  on: { input: _vm.fnOnESignMenuChange },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ attrs, on }) {
                          return [
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    class: {
                                      selected: _vm.selectedPath
                                        .toLowerCase()
                                        .includes("/esign"),
                                      shadowhover: true,
                                    },
                                    attrs: { tag: "a" },
                                  },
                                  "button",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("span", { staticClass: "nav-button" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.navigation_bar.title_esign_minus"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-icon",
                                  {
                                    class: {
                                      rotate90: _vm.esignMenuIsActive,
                                      "animated-icon": true,
                                    },
                                    attrs: { color: "#ffffff" },
                                  },
                                  [_vm._v("mdi-menu-right")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    232216667
                  ),
                },
                [
                  _vm._v(" "),
                  _vm.$store.getters.isInRoleArr(
                    "ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index,View_TetrisESignArea/TetrisESign/Index,JLLT_VIEW,HR_ADMIN"
                  )
                    ? _c(
                        "v-list",
                        { staticClass: "menulistitem" },
                        [
                          _vm.$store.getters.isInRoleArr(
                            "ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index"
                          )
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      class: {
                                        selected:
                                          _vm.selectedPath
                                            .toLowerCase()
                                            .includes("/esign") &&
                                          !_vm.selectedPath
                                            .toLowerCase()
                                            .includes("/esigntetris") &&
                                          !_vm.selectedPath
                                            .toLowerCase()
                                            .includes("/esigndashboard") &&
                                          !_vm.selectedPath
                                            .toLowerCase()
                                            .includes("/esignjllt") &&
                                          !_vm.selectedPath
                                            .toLowerCase()
                                            .includes("/esignhr"),
                                        shadowhover: true,
                                      },
                                      attrs: { to: "/ESign", tag: "a" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "nav-button",
                                          attrs: { color: "#ffffff" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.navigation_bar.title_esign_JLL"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$store.getters.isInRoleArr(
                            "ADMIN,R_TETRIS_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index"
                          )
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      class: {
                                        selected: _vm.selectedPath
                                          .toLowerCase()
                                          .includes("/esigntetris"),
                                        shadowhover: true,
                                      },
                                      attrs: { to: "/ESignTetris", tag: "a" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "nav-button",
                                          attrs: { color: "#ffffff" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.navigation_bar.title_esign_TETRIS"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$store.getters.isInRoleArr("JLLT_VIEW")
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      class: {
                                        selected: _vm.selectedPath
                                          .toLowerCase()
                                          .includes("/esignjllt"),
                                        shadowhover: true,
                                      },
                                      attrs: { to: "/ESignJLLT", tag: "a" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "nav-button",
                                          attrs: { color: "#ffffff" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.navigation_bar.title_esign_JLLT"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$store.getters.isInRoleArr("ADMIN, HR_ADMIN")
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      class: {
                                        selected: _vm.selectedPath
                                          .toLowerCase()
                                          .includes("/esignhr"),
                                        shadowhover: true,
                                      },
                                      attrs: { to: "/ESignHR", tag: "a" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "nav-button",
                                          attrs: { color: "#ffffff" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.navigation_bar.title_esign_HR"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$store.getters.isInRoleArr(
                            "DASHBOARD_OVERVIEW,DASHBOARD_JLL,DASHBOARD_TETRIS"
                          )
                            ? _c("hr")
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$store.getters.isInRoleArr(
                            "DASHBOARD_OVERVIEW,DASHBOARD_JLL,DASHBOARD_TETRIS"
                          )
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      class: {
                                        selected: _vm.selectedPath
                                          .toLowerCase()
                                          .includes("/esigndashboard"),
                                        shadowhover: true,
                                      },
                                      attrs: {
                                        to: "/ESignDashboard",
                                        tag: "a",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "nav-button",
                                          attrs: { color: "#ffffff" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.navigation_bar.title_esign_dashboard"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.isInRoleArr(
            "View_AdminArea/Users/MngUsers,View_AdminArea/Users/MngProfiles,View_AdminArea/Users/MngRoles,DEV_MODE,ADMIN,R_ESIGN_ADMIN,R_ESIGN_TETRIS_ADMIN"
          )
            ? _c(
                "v-menu",
                {
                  attrs: {
                    dark: "",
                    "offset-y": "",
                    transition: "slide-y-transition",
                    rounded: "10",
                    "content-class": "elevation-2",
                  },
                  on: { input: _vm.fnOnAdminMenuChange },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ attrs, on }) {
                          return [
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    class: {
                                      selected: _vm.selectedPath
                                        .toLowerCase()
                                        .includes("/admin"),
                                      shadowhover: true,
                                    },
                                    attrs: { tag: "a" },
                                  },
                                  "button",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("span", { staticClass: "nav-button" }, [
                                  _vm._v(" Admin "),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-icon",
                                  {
                                    class: {
                                      rotate90: _vm.adminMenuIsActive,
                                      "animated-icon": true,
                                    },
                                    attrs: { color: "#ffffff" },
                                  },
                                  [_vm._v("mdi-menu-right")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1654863562
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { staticClass: "menulistitem" },
                    [
                      _vm.$store.getters.isInRoleArr("ADMIN")
                        ? _c("v-list-item", [
                            _c(
                              "button",
                              {
                                staticClass: "shadowhover",
                                on: { click: _vm.fnRefreshCache },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "nav-button",
                                    attrs: { color: "#ffffff" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.navigation_bar.title_refresh_cache"
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters.isInRoleArr(
                        "View_AdminArea/Users/MngUsers,ADMIN,R_ESIGN_ADMIN"
                      )
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "router-link",
                                {
                                  class: {
                                    selected: _vm.selectedPath
                                      .toLowerCase()
                                      .includes("/admin/users"),
                                    shadowhover: true,
                                  },
                                  attrs: { to: "/Admin/Users", tag: "a" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav-button",
                                      attrs: { color: "#ffffff" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.navigation_bar.title_users"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters.isInRoleArr(
                        "View_AdminArea/Users/MngProfiles,ADMIN"
                      )
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "router-link",
                                {
                                  class: {
                                    selected: _vm.selectedPath
                                      .toLowerCase()
                                      .includes("/admin/profiles"),
                                    shadowhover: true,
                                  },
                                  attrs: { to: "/Admin/Profiles", tag: "a" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav-button",
                                      attrs: { color: "#ffffff" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.navigation_bar.title_profiles"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters.isInRoleArr(
                        "View_AdminArea/Users/MngRoles,ADMIN"
                      )
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "router-link",
                                {
                                  class: {
                                    selected: _vm.selectedPath
                                      .toLowerCase()
                                      .includes("/admin/roles"),
                                    shadowhover: true,
                                  },
                                  attrs: { to: "/Admin/Roles", tag: "a" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav-button",
                                      attrs: { color: "#ffffff" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.navigation_bar.title_roles"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters.isInRole("DEV_MODE")
                        ? _c("hr")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters.isInRoleArr(
                        "R_ESIGN_ADMIN,R_TETRIS_ESIGN_ADMIN,ADMIN"
                      )
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "router-link",
                                {
                                  class: {
                                    selected: _vm.selectedPath
                                      .toLowerCase()
                                      .includes("/admin/approvers"),
                                    shadowhover: true,
                                  },
                                  attrs: { to: "/Admin/Approvers", tag: "a" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav-button",
                                      attrs: { color: "#ffffff" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.navigation_bar.title_approvers"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters.isInRole(
                        "R_ESIGN_ADMIN,R_TETRIS_ESIGN_ADMIN,ADMIN"
                      )
                        ? _c("hr")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters.isInRole("DEV_MODE")
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    dark: "",
                                    "offset-x": "",
                                    transition: "slide-x-transition",
                                    rounded: "10",
                                    "content-class": "elevation-2",
                                    "open-on-hover": "",
                                    "slide-x": "",
                                  },
                                  on: { input: _vm.fnOnDevMenuChange },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ attrs, on }) {
                                          return [
                                            _c(
                                              "button",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "shadowhover",
                                                    attrs: { tag: "button" },
                                                  },
                                                  "button",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "nav-button" },
                                                  [_vm._v(" CHANGE INSTANCE ")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    class: {
                                                      translate3:
                                                        _vm.devMenuIsActive,
                                                      "animated-icon": true,
                                                    },
                                                  },
                                                  [_vm._v("mdi-menu-right")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    535697118
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { staticClass: "menulistitem" },
                                    [
                                      _c("v-list-item", [
                                        _c(
                                          "button",
                                          {
                                            class: {
                                              selected:
                                                _vm.$store.getters.instance ==
                                                "es",
                                              langButton: true,
                                              shadowhover: true,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.fnSetInstance("es")
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "nav-button flag",
                                              },
                                              [
                                                _c("country-flag", {
                                                  attrs: {
                                                    country: "es",
                                                    size: "small",
                                                    rounded: "",
                                                  },
                                                }),
                                                _vm._v(
                                                  "  \n                                        Spain\n                                    "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-item", [
                                        _c(
                                          "button",
                                          {
                                            class: {
                                              selected:
                                                _vm.$store.getters.instance ==
                                                "pt",
                                              langButton: true,
                                              shadowhover: true,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.fnSetInstance("pt")
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "nav-button flag",
                                              },
                                              [
                                                _c("country-flag", {
                                                  attrs: {
                                                    country: "pt",
                                                    size: "small",
                                                    rounded: "",
                                                  },
                                                }),
                                                _vm._v(
                                                  "  \n                                        Portugal\n                                    "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-item", [
                                        _c(
                                          "button",
                                          {
                                            class: {
                                              selected:
                                                _vm.$store.getters.instance ==
                                                "it",
                                              langButton: true,
                                              shadowhover: true,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.fnSetInstance("it")
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "nav-button flag",
                                              },
                                              [
                                                _c("country-flag", {
                                                  attrs: {
                                                    country: "it",
                                                    size: "small",
                                                    rounded: "",
                                                  },
                                                }),
                                                _vm._v(
                                                  "  \n                                        Italy\n                                    "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters.isInRoleArr("ADMIN")
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "router-link",
                                {
                                  class: {
                                    selected: _vm.selectedPath
                                      .toLowerCase()
                                      .includes("/authmappings"),
                                    shadowhover: true,
                                  },
                                  attrs: {
                                    to: "/admin/AuthMappings",
                                    tag: "a",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav-button",
                                      attrs: { color: "#ffffff" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.navigation_bar.title_authmappings"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters.isInRoleArr("ADMIN")
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "router-link",
                                {
                                  class: {
                                    selected: _vm.selectedPath
                                      .toLowerCase()
                                      .includes("/healthcheck"),
                                    shadowhover: true,
                                  },
                                  attrs: { to: "/HealthCheck", tag: "a" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "nav-button",
                                      attrs: { color: "#ffffff" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.navigation_bar.title_healthchecks"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow-1" }),
      _vm._v(" "),
      _c(
        "v-toolbar-items",
        [
          _c(
            "div",
            { staticClass: "flag" },
            [
              _c("country-flag", {
                attrs: {
                  country: _vm.countryFlagByInstance,
                  size: "small",
                  rounded: "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-menu",
            {
              attrs: {
                dark: "",
                "offset-y": "",
                "offset-x": "",
                transition: "slide-y-transition",
                rounded: "10",
                "content-class": "elevation-2",
              },
              on: { input: _vm.fnOnLogoMenuChange },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ attrs, on }) {
                    return [
                      _c(
                        "button",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "shadowhover",
                              attrs: { tag: "button" },
                            },
                            "button",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("span", { staticClass: "nav-button" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../../assets/JLLlogo.png"),
                                height: "40px",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              class: {
                                rotate90: _vm.logoMenuIsActive,
                                "animated-icon": true,
                              },
                              attrs: { color: "#ffffff" },
                            },
                            [_vm._v("mdi-menu-right")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "v-list",
                { staticClass: "menulistitem" },
                [
                  _c("v-list-item", [
                    _c("button", { on: { click: _vm.fnLogout } }, [
                      _c("span", { staticClass: "nav-button inline-flex" }, [
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.userName) + "      "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "shadowhover logoutbutton",
                                attrs: { color: "#d68585" },
                              },
                              [_vm._v("mdi-logout")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-list-item", [
                    _c("button", [
                      _c("span", { staticClass: "mailtext" }, [
                        _vm._v("     (" + _vm._s(_vm.userEmail) + ")     "),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "router-link",
                        {
                          class: {
                            selected: _vm.selectedPath
                              .toLowerCase()
                              .includes("/about"),
                            shadowhover: true,
                          },
                          attrs: { to: "/About", tag: "a" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "nav-button",
                              attrs: { color: "#ffffff" },
                            },
                            [_vm._v(" About")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            dark: "",
                            "offset-x": "",
                            left: true,
                            rounded: "10",
                            "content-class": "elevation-2",
                            "open-on-hover": "",
                            "slide-x": "",
                          },
                          on: { input: _vm.fnOnLangMenuChange },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ attrs, on }) {
                                return [
                                  _c(
                                    "button",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "shadowhover",
                                          attrs: { tag: "button" },
                                        },
                                        "button",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "nav-button" },
                                        [_vm._v(" Language ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-icon",
                                        {
                                          class: {
                                            rotate180: _vm.langMenuIsActive,
                                            "animated-icon": true,
                                          },
                                        },
                                        [_vm._v("mdi-menu-right")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { staticClass: "menulistitem" },
                            [
                              _c("v-list-item", [
                                _c(
                                  "button",
                                  {
                                    class: {
                                      selected:
                                        _vm.$store.getters.langCode == "en",
                                      langButton: true,
                                      shadowhover: true,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.fnSetLanguage("en")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "nav-button flag" },
                                      [
                                        _c("country-flag", {
                                          attrs: {
                                            country: "gb",
                                            size: "small",
                                            rounded: "",
                                          },
                                        }),
                                        _vm._v(
                                          "   \n                                        English\n                                    "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item", [
                                _c(
                                  "button",
                                  {
                                    class: {
                                      selected:
                                        _vm.$store.getters.langCode == "es",
                                      langButton: true,
                                      shadowhover: true,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.fnSetLanguage("es")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "nav-button flag" },
                                      [
                                        _c("country-flag", {
                                          attrs: {
                                            country: "es",
                                            size: "small",
                                            rounded: "",
                                          },
                                        }),
                                        _vm._v(
                                          "   \n                                        Spanish\n                                    "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item", [
                                _c(
                                  "button",
                                  {
                                    class: {
                                      selected:
                                        _vm.$store.getters.langCode == "it",
                                      langButton: true,
                                      shadowhover: true,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.fnSetLanguage("it")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "nav-button flag" },
                                      [
                                        _c("country-flag", {
                                          attrs: {
                                            country: "it",
                                            size: "small",
                                            rounded: "",
                                          },
                                        }),
                                        _vm._v(
                                          "   \n                                        Italian\n                                    "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item", [
                                _c(
                                  "button",
                                  {
                                    class: {
                                      selected:
                                        _vm.$store.getters.langCode == "pt",
                                      langButton: true,
                                      shadowhover: true,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.fnSetLanguage("pt")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "nav-button flag" },
                                      [
                                        _c("country-flag", {
                                          attrs: {
                                            country: "pt",
                                            size: "small",
                                            rounded: "",
                                          },
                                        }),
                                        _vm._v(
                                          "   \n                                        Portuguese\n                                    "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.documentationConfig != undefined
                    ? _c(
                        "v-list-item",
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                dark: "",
                                "offset-x": "",
                                left: true,
                                rounded: "10",
                                "content-class": "elevation-2",
                                "open-on-hover": "",
                                "slide-x": "",
                              },
                              on: { input: _vm.fnOnDocuMenuChange },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ attrs, on }) {
                                      return [
                                        _c(
                                          "button",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "shadowhover",
                                                attrs: { tag: "button" },
                                              },
                                              "button",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "nav-button" },
                                              [_vm._v(" Documentation ")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-icon",
                                              {
                                                class: {
                                                  rotate180:
                                                    _vm.DocuMenuIsActive,
                                                  "animated-icon": true,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    mdi-menu-right\n                                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3449089340
                              ),
                            },
                            [
                              _vm._v(" "),
                              _vm.documentationConfig != undefined
                                ? _c(
                                    "v-list",
                                    { staticClass: "menulistitem" },
                                    _vm._l(
                                      _vm.documentationConfig,
                                      function (item, idx) {
                                        return _c("v-list-item", { key: idx }, [
                                          !item.external
                                            ? _c(
                                                "button",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.fnDownloadESignDocumentation(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "nav-button shadowhover",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                       " +
                                                          _vm._s(
                                                            _vm.$t(item.title)
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.external
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: item.url,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "nav-button shadowhover",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                       " +
                                                          _vm._s(
                                                            _vm.$t(item.title)
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ])
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }